import { render, staticRenderFns } from "./Ccl.vue?vue&type=template&id=28a7f78b&scoped=true&"
import script from "./Ccl.vue?vue&type=script&lang=js&"
export * from "./Ccl.vue?vue&type=script&lang=js&"
import style0 from "./Ccl.vue?vue&type=style&index=0&id=28a7f78b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28a7f78b",
  null
  
)

export default component.exports